import {customAxios, IDUSUARIO, GENERIC_URL} from '../constants';

export default function (coGrupo) {
    const config = {
        params: {
            codGrupo: coGrupo.length < 1 ? '' : `${coGrupo}`
        },
        headers: {
            idUsuario: IDUSUARIO,
            'Content-Type': 'application/json',
        },
    };

    return customAxios.get(`${GENERIC_URL}/logistica/maestro/listardatos`, config,);
}



// WEBPACK FOOTER //
// ./src/utils/getTablaTipos.js